import {
  StyleSheet,
  View,
  ViewStyle,
  FlatList,
  Pressable,
  TextStyle,
  ScrollView,
} from 'react-native';
import React, {useState} from 'react';
import {Text} from 'ui-kits';
import {corner_radius, spacing} from 'theme/Units';
import colors from 'theme/Colors';
import {StoryTask, StoryIssues, StoryForm, StoryDescription,StoryAttachment,StoryComments,StoryDependencies,StoryHistory} from './StoryTabsComponents';
import {FormikProps} from 'formik';
import { userStoryFormValuesType } from './userStoryFormValuesType';


type propsType = Readonly<{
  mode: 'add' | 'edit' | 'view';
  initialValues: userStoryFormValuesType,
}> &
  FormikProps<userStoryFormValuesType>;

export function StoryTabs(props: propsType) {

  const {mode, initialValues, ...rest} = props;
  const tabsMap = {
    Details: <StoryForm mode={mode} {...rest} initialValues={initialValues} />,
    Description: <StoryDescription mode={mode} {...rest} initialValues={initialValues}/>,
    Task: <StoryTask />,
    Issues: <StoryIssues />,
    Comments: <StoryComments />,
    Attachment: <StoryAttachment />,
    History: <StoryHistory />,
    Dependencies: <StoryDependencies />,
  } as const;

  type TabType = keyof typeof tabsMap;
  const tabs = Object.keys(tabsMap) as any[];
  const [currentTab, setCurrentTab] = useState<TabType>('Details');

  const seperator = () => (
    <View style={styles.seperator} />
  )

  return (
    <View style={styles.container}>
      {/* tabs */}
      <View>
        <ScrollView horizontal={true} showsHorizontalScrollIndicator={false}>
          <FlatList
            data={tabs}
            renderItem={({item}: {item: TabType}) => (
              <Pressable onPress={() => setCurrentTab(item)}>
                <Text
                  style={[
                    styles.tab,
                    item === currentTab ? styles.currentTab : null,
                  ]}>
                  {item}
                </Text>
              </Pressable>
            )}
            keyExtractor={item => item}
            horizontal={true}
            style={styles.tabs}
            ItemSeparatorComponent={seperator} 
          />
        </ScrollView>
      </View>
      <View style={styles.tabContent}>{tabsMap[currentTab]}</View>
    </View>
  );
}

type styleType = {
  container: ViewStyle;
  currentTab: TextStyle;
  tab: TextStyle;
  tabs: ViewStyle;
  tabContent: ViewStyle;
  seperator: ViewStyle;
};
const styles: styleType = StyleSheet.create({
  seperator: {width: spacing['2']},
  container: {
    flex: 1,
    backgroundColor: '#B7B3E966',
    borderRadius: corner_radius['rounded-lg'] + corner_radius['rounded-lg'],
    paddingBottom: spacing['4'],
  },
  currentTab: {
    backgroundColor: colors.palette.brandBlue,
    color: colors.palette.white,
    opacity: 1,
  },
  tab: {
    fontSize: 20,
    paddingHorizontal: spacing['3'],
    paddingVertical: spacing['1'],
    color: colors.palette.secondaryBlack5,
    backgroundColor: colors.palette.white,
    borderRadius: 999,
  },
  tabs: {
    padding: spacing['2'],
    flexGrow: 0,
    flexShrink: 1,
    alignSelf: 'flex-start',
    overflow: 'hidden',
    width: '100%',
    marginHorizontal: spacing['1'],
    zIndex: -22,
  },
  tabContent: {
    flex: 1,
    borderWidth: 1,
    borderColor: colors.palette.stroke,
    borderRadius: corner_radius['rounded-lg'] + corner_radius['rounded-lg'],
    backgroundColor: 'white',
    zIndex: 100,
  },
});
